jQuery.noConflict();
(function($) {
  function cartPage() {
    if ($('body').hasClass('woocommerce-cart')) {
      //Change total subtotal label
      $('.woocommerce-cart-form .shop_table th.product-subtotal').text('Total');

      //Moove return to shop button
      if ($('html').attr('lang') == 'fr-FR') {
        $('.woocommerce-cart-form .continue-shopping.pull-left .button-continue-shopping').text('Poursuivre vers la navigation');
      }
      if ($('html').attr('lang') == 'en-US') {
        $('.woocommerce-cart-form .continue-shopping.pull-left .button-continue-shopping').text('Continue to navigation');
      }
      $('.woocommerce-cart-form .continue-shopping.pull-left').insertAfter('.wc-proceed-to-checkout ');

      //Change cross-sells products add to cart button text
      if ($('html').attr('lang') == 'fr-FR') {
        $('.woocommerce-cart-form .cross-sells .button').text('Ajouter');
        $('.woocommerce-cart-form .up-sells .button').text('Ajouter');
      }
      if ($('html').attr('lang') == 'en-US') {
        $('.woocommerce-cart-form .up-sells .button').text('Add');
        $('.woocommerce-cart-form .up-sells .button').text('Add');
      }
    }
  }
  cartPage();

  $(document.body).on('updated_cart_totals', function() {
    if ($('body').hasClass('woocommerce-cart')) {
      cartPage();
    }
  });

  function couponSlideToggle() {
    //Coupon slide toggle
    $('.cart-collaterals .coupon input').wrapAll("<div class='coupon-inputs'></div>");

    $(document).on('click', '.cart-collaterals .coupon .widget-title', function(e) {
      const $child = $(this).siblings('.coupon-inputs');
      $(this).toggleClass('open');
      if ($(this).hasClass('open')) {
        $child.slideDown();
      } else {
        $child.slideUp();
      }
    });
  }
  couponSlideToggle();
})(jQuery);
